export default __webpack_public_path__ + "static/media/Referrers.c8273e10.svg";